import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { routeBackdrop, subscribeBackdrop } from "../lib/backdrop";

/* Fixed full-viewport layer: image + theme-tuned scrim + grain. Sits behind all page content. */
export default function PageBackdrop() {
  const { pathname } = useLocation();
  const [override, setOverride] = useState(null);
  useEffect(() => subscribeBackdrop(setOverride), []);
  const base = routeBackdrop(pathname);
  const image = override || base.image;
  if (base.tone === "none" || !image) return null;
  return (
    <div className={`page-backdrop tone-${base.tone}`} data-testid="page-backdrop" data-image={image} aria-hidden="true">
      <div className="page-backdrop-img" key={image} style={{ backgroundImage: `url(${image})` }} />
      <div className="page-backdrop-scrim" />
      <div className="page-backdrop-grain" />
    </div>
  );
}
